import { useEffect, useRef, useState } from "react";

import { useNativeSubscription } from "@accurx/native";

export const useOnWindowReset = ({ onReset }: { onReset: () => void }) => {
    const { data } = useNativeSubscription("SubscribeWindowOpenStatus");

    const newResetCount = data?.resetCount ?? 0;
    const [resetCount, setResetCount] = useState<number>(newResetCount);
    const onResetRef = useRef(onReset);

    useEffect(() => {
        onResetRef.current = onReset;
    }, [onReset]);

    useEffect(() => {
        if (newResetCount !== resetCount) {
            if (newResetCount > resetCount) {
                onResetRef.current();
            }
            setResetCount(newResetCount);
        }
    }, [newResetCount, resetCount]);
};
